import requestFunctions from "../../functions/requestFunctions";


export const state = {

  CONTACTS_ITEM: {},
  CONTACTS_LIST: [],
  CONTACTS_TABLE_DATA: [],
  CONTACTS_TOTAL_ROWS: 0
}

export const getters = {
  GET_CONTACTS_ITEM: (state) => {
    return state.CONTACTS_ITEM;
  },
  GET_CONTACTS_LIST: (state) => {
    return state.CONTACTS_LIST;
  },
  GET_CONTACTS_TABLE_DATA: (state) => {
    return state.CONTACTS_TABLE_DATA;
  },
  GET_CONTACTS_TOTAL_ROWS: (state) => {
    return state.CONTACTS_TOTAL_ROWS;
  }
}

export const mutations = {

  UPDATE_CONTACTS_ITEM(state, item) {
    state.CONTACTS_ITEM = item;
  },

  UPDATE_CONTACTS_LIST(state, list) {

    state.CONTACTS_LIST = list.data;
    state.CONTACTS_TABLE_DATA = [];

    state.CONTACTS_TOTAL_ROWS = list.total;
    list = list.data;

    let status = '';

    if(list !== null) {
      list.forEach(el => {

        if(el.status === 'active'){
          status = 'Активный'
        }
        if(el.status === 'wait'){
          status = 'На модерации'
        }
        if(el.status === 'blocked'){
          status = 'Заблокирован'
        }
        if(el.status === 'archive'){
          status = 'В архиве'
        }

        let user_data = '';
    
        if(el.profile_fullname !== null){
          user_data = el.profile_fullname;
        }
        
        if(el.user_phone !== null ){
          if(user_data !== ''){
            user_data = user_data + ', ';
          }
          user_data = user_data + el.user_phone;
        }

        state.CONTACTS_TABLE_DATA.push({
          'id'        : el.id,
          'uuid'      : el.uuid,
          'fullname'  : el.fullname,
          'phone'     : el.phone,
          'city_name' : el.city_name,
          'status'    : status,
          'user_data' : user_data, 
          'category_name' : el.category_name,
        });
      });
    }
  },
}

export const actions = {

  async FETCH_CONTACTS_ITEM({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/contacts/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_CONTACTS_ITEM', response.data);
      return response.data;
    }

  },

  async FETCH_CONTACTS_LIST({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/contacts';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_CONTACTS_LIST', response.data);
      return response.data;
    }

  },

  async FETCH_CONTACTS_CREATE({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/contacts';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'POST');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }

  },

  async FETCH_CONTACTS_UPDATE({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/contacts/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'PUT');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }

  },

  async FETCH_CONTACTS_DELETE({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/contacts/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'DELETE');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }

  },

}